<div class="ai-hub-form pl-3 mt-3">
    <img src="./assets/img/asset-logo.svg" class="asset-logo"/>
    <h4 class="d-inline-block">Business Intelligence Insights</h4>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="showForm">
        <div *ngFor="let control of formJson">

            <!-- Text -->
            <div *ngIf="control.type === 'text'" class="input-element">
                <label>{{control.label}}</label>
                <input type="text" formControlName="{{control.name}}" class="w-100">
            </div>

            <!-- Dropdown -->
            <div *ngIf="control.type === 'dropdown'" class="input-element">
                <label>{{control.label}}</label>
                <mat-form-field appearance="fill">
                    <mat-label>Select...</mat-label>
                    <mat-select>
                        <mat-option *ngFor="let option of control.options" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Audio -->
            <div *ngIf="control.type === 'audio'" class="input-element">
                <label>{{control.label}}</label>
                <app-audio></app-audio>
            </div>

            <!-- Toggle -->
            <div *ngIf="control.type === 'toggle'" class="input-element">
                <mat-slide-toggle formControlName="{{control.name}}">
                    Include emoticons in the post ?
                </mat-slide-toggle>
            </div>

            <!-- Textarea -->
            <div *ngIf="control.type === 'textarea'" class="input-element">
                <label>{{control.label}}</label>
                <textarea formControlName="{{control.name}}" rows="3" class="w-100"></textarea>
            </div>

            <!-- Upload -->
            <div *ngIf="control.type === 'upload'" class="input-element">
                <label>{{control.label}}</label>
                <ngx-file-drop (onFileDrop)="drop($event)" [dropZoneClassName]="'asset-logo--dropzone'" [showBrowseBtn]="false" [accept]="'.png,.svg'" [multiple]="false">
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                        <button type="button" (click)="openFileSelector()">
                            <img src="./assets/img/upload.svg" alt="" />
                        </button>
                        <p class="text">
                            Browse & Upload
                        </p>
                    </ng-template>
                </ngx-file-drop>
            </div>
        </div>

        <button class="btn btn-primary input-element" type="submit()">
            Submit
        </button>
    </form>
</div>
